import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

interface Props {
  show: boolean;
  onHide: () => void;
  onSubmit: (comment: string) => Promise<void>;
}

const ReportIssueModal: React.FC<Props> = ({ show, onHide, onSubmit }) => {
  const [comment, setComment] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    if (comment.trim().length < 4) {
      setError("Comment must be at least 4 characters.");
      return;
    }
    setError("");
    setSubmitting(true);
    try {
      await onSubmit(comment.trim());
      setComment("");
    } catch (err: any) {
      setError(err?.message || "Failed to report issue");
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setComment("");
    setError("");
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Report Issue</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Describe the issue:</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Enter your comment (min 4 characters)..."
          />
        </Form.Group>
        {error && (
          <div style={{ color: "red", marginTop: "8px", fontSize: "0.85em" }}>
            {error}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="danger"
          size="sm"
          onClick={handleSubmit}
          disabled={submitting}
        >
          {submitting ? "Reporting..." : "Report Issue"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReportIssueModal;
